<template>
    <div class="card">
        <div class="card-header">
            <strong>Add Files ({{ files.length }}):</strong>
        </div>
        <div class="card-body">
            <div :class="{'row mb-3': rowClass !== null}">
                <div v-for="(file, i) in files" :class="fileRowClass">
                    <hr v-if="i > 0 && !rowClass" />
                    <div class="row mb-2">
                        <div class="col-md-10">
                            <b-form-input v-model="files[i].file_name" placeholder="Enter a Custom File Name (Optional)" size="sm" />
                        </div>
                        <div class="col-md-2">
                            <button type="button" v-on:click="files.splice(i, 1)" class="btn btn-xs btn-default"><i class="fa fa-trash text-danger"></i></button>
                        </div>
                    </div>

                    <b-form-file v-model="files[i].file" placeholder="Select a File" size="sm" />

                    <div v-if="sensitive && $root.hasPermission('agents.view.sensitive')" class="mt-2">
                        <b-form-checkbox v-model="files[i].is_sensitive" :value="true" :unchecked-value="false" plain>
                            File is Sensitive <i class="fa fa-question-circle" title="Sensitive Files can only be viewed by Sensitive-Authorized users via the permissions settings."></i>
                        </b-form-checkbox>
                    </div>

                    <div class="text-danger mt-1" v-if="errors.files && errors.files[i]">
                        <ul class="list-unstyled">
                            <li v-for="err in errors.files[i]">{{ err }}</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div id="add-file" class="text-center py-2 px-3" v-on:click="addFile()">
                <i class="fa fa-plus-circle text-success"></i> Add File
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            rowClass: {
                type: String,
                default: null
            },

            sensitive: {
                type: Boolean,
                default: false
            },
        },

        data() {
            return {
                files: [],
                errors: {},
            }
        },

        computed: {
            fileRowClass(){
                //Setup
                var classes = {'mb-3': true};

                //Check for prop
                if(this.rowClass)
                {
                    classes[this.rowClass] = true;
                }

                //Send it
                return classes;
            },
        },

        methods: {
            setErrors(errors){
                this.errors = errors;
            },

            getFiles(){
                return this.files;
            },

            reset(){
                this.files = [];
            },

            getFilesForSave(){
                //Setup
                var file_names = [];
                var file_items = [];
                var file_sensitive = [];

                //Build the File Names and File Objects
                for (var i = 0; i < this.files.length; i++)
                {
                    //Push the name and files
                    file_names.push(this.files[i].file_name);
                    file_items.push(this.files[i].file);

                    //Check for Sensitive
                    if(this.sensitive)
                    {
                        file_sensitive.push(this.files[i].is_sensitive);
                    }
                }

                //Send it
                return {
                    'file_names': file_names,
                    'files': file_items,
                    'file_sensitive': file_sensitive,
                };
            },

            addFile(){
                //Push
                var new_file = {
                    file_name: '',
                    file: null
                };

                //Check sensitive
                if(this.sensitive && this.$root.hasPermission('agents.view.sensitive'))
                {
                    //Push
                    new_file['is_sensitive'] = true;
                }

                //push it
                this.files.push(new_file);
            },
        },

        mounted() {

        }
    }
</script>

<style type="text/css">
    #add-file {
        border: 1px dashed #ccc;
    }

    #add-file:hover {
        cursor: pointer;
    }
</style>